// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var User$SmartcutsMacros = require("./User.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    if (v === /* UnknownAuthStatus */0) {
      return ["UnknownAuthStatus"];
    } else {
      return ["LoggedOut"];
    }
  } else if (v.TAG === /* LoggedIn */0) {
    return [
            "LoggedIn",
            User$SmartcutsMacros.t_encode(v._0)
          ];
  } else {
    return [
            "AuthError",
            Decco.stringToJson(v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AuthError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AuthError */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "LoggedIn" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = User$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LoggedIn */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "LoggedOut" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* LoggedOut */1
                  };
          }
      case "UnknownAuthStatus" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UnknownAuthStatus */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(status) {
  if (typeof status === "number") {
    if (status === /* UnknownAuthStatus */0) {
      return "UnknownAuthStatus";
    } else {
      return "LoggedOut";
    }
  }
  if (status.TAG !== /* LoggedIn */0) {
    return "AuthError(" + (status._0 + ")");
  }
  var match = status._0;
  return "LoggedIn({token: " + (match.token.slice(0, 4) + (", userId: " + (match.userId + (", email: " + (match.email + (", role: " + (Curry._1(User$SmartcutsMacros.UserRole.tToJs, match.role) + "})")))))));
}

function storeItemInBrowserStorage(key, value) {
  return browser.storage.local.set(Js_dict.fromList({
                  hd: [
                    key,
                    value
                  ],
                  tl: /* [] */0
                }));
}

function getStoredItemFromBrowserStorage(key) {
  return browser.storage.local.get(key).then(function (storageResult) {
              return Promise.resolve(Js_dict.get(storageResult, key));
            });
}

function storeTokenInBrowserStorage(token) {
  return storeItemInBrowserStorage("token", token);
}

function storeUserIdInBrowserStorage(userId) {
  return storeItemInBrowserStorage("userId", userId);
}

function storeUserEmailInBrowserStorage(email) {
  return storeItemInBrowserStorage("email", email);
}

function storeUserRoleInBrowserStorage(role) {
  return storeItemInBrowserStorage("role", Curry._1(User$SmartcutsMacros.UserRole.tToJs, role));
}

function storeUserBuildInBrowserStorage(build) {
  return storeItemInBrowserStorage("build", Curry._1(User$SmartcutsMacros.ExtensionBuild.tToJs, build));
}

function storeUserUserFlagsInBrowserStorage(userFlags) {
  return storeItemInBrowserStorage("user_flags", JSON.stringify(Json_encode.array((function (prim) {
                        return prim;
                      }), userFlags)));
}

function storeUserFinishedOnboardingInBrowserStorage(finishedOnboarding) {
  return storeItemInBrowserStorage("finished_onboarding", Pervasives.string_of_bool(finishedOnboarding));
}

function clearStoredTokenFromBrowserStorage(param) {
  return browser.storage.local.remove("token");
}

function clearAllStoredUserInfoFromBrowserStorage(param) {
  return Promise.all($$Array.map((function (prim) {
                      return browser.storage.local.remove(prim);
                    }), [
                    "token",
                    "userId",
                    "email",
                    "role",
                    "build",
                    "user_flags",
                    "finished_onboarding"
                  ])).then(function (param) {
              return Promise.resolve(undefined);
            });
}

function getTokenFromBrowserStorage(param) {
  return getStoredItemFromBrowserStorage("token");
}

function getUserRoleFromBrowserStorage(param) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (resultString) {
                return Belt_Option.flatMap(resultString, User$SmartcutsMacros.UserRole.tFromJs);
              }), getStoredItemFromBrowserStorage("role"));
}

function getUserBuildFromBrowserStorage(param) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (resultString) {
                return Belt_Option.flatMap(resultString, User$SmartcutsMacros.ExtensionBuild.tFromJs);
              }), getStoredItemFromBrowserStorage("build"));
}

function getUserFlagsFromBrowserStorage(param) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (maybeResultString) {
                var arg = Belt_Option.flatMap(maybeResultString, (function (jsonString) {
                        try {
                          return Json_decode.array(Json_decode.string, JSON.parse(jsonString));
                        }
                        catch (exn){
                          return ;
                        }
                      }));
                var param = [];
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              }), getStoredItemFromBrowserStorage("user_flags"));
}

function getUserFinishedOnboardingFromBrowserStorage(param) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (maybeResultString) {
                var arg = Belt_Option.map(maybeResultString, Pervasives.bool_of_string);
                var param = false;
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              }), getStoredItemFromBrowserStorage("finished_onboarding"));
}

function getFromBrowserStorage(param) {
  return Promise.all([
                  getTokenFromBrowserStorage(undefined),
                  getStoredItemFromBrowserStorage("userId"),
                  getStoredItemFromBrowserStorage("email"),
                  getUserRoleFromBrowserStorage(undefined),
                  getUserBuildFromBrowserStorage(undefined)
                ]).then(function (param) {
                var maybeBuild = param[4];
                var maybeUserRole = param[3];
                var maybeEmail = param[2];
                var maybeUserId = param[1];
                var maybeToken = param[0];
                return Promise.all([
                              getUserFlagsFromBrowserStorage(undefined),
                              getUserFinishedOnboardingFromBrowserStorage(undefined)
                            ]).then(function (param) {
                            return Promise.resolve([
                                        maybeToken,
                                        maybeUserId,
                                        maybeEmail,
                                        maybeUserRole,
                                        maybeBuild,
                                        param[0],
                                        param[1]
                                      ]);
                          });
              }).then(function (param) {
              var maybeUserRole = param[3];
              var maybeEmail = param[2];
              var maybeUserId = param[1];
              var maybeToken = param[0];
              return Promise.resolve(maybeToken !== undefined && maybeUserId !== undefined && maybeEmail !== undefined && maybeUserRole !== undefined ? ({
                              TAG: /* LoggedIn */0,
                              _0: {
                                token: maybeToken,
                                userId: maybeUserId,
                                email: maybeEmail,
                                role: maybeUserRole,
                                build: param[4],
                                finishedOnboarding: param[6],
                                userFlags: param[5]
                              }
                            }) : /* LoggedOut */1);
            });
}

function calcAuthStatusUpdate(oldStatus, newStatus) {
  if (typeof oldStatus === "number") {
    if (oldStatus === /* UnknownAuthStatus */0) {
      if (typeof newStatus === "number" && newStatus === /* UnknownAuthStatus */0) {
        return ;
      } else {
        return newStatus;
      }
    } else if (typeof newStatus === "number" && newStatus !== /* UnknownAuthStatus */0) {
      return ;
    } else {
      return newStatus;
    }
  }
  if (oldStatus.TAG !== /* LoggedIn */0) {
    if (typeof newStatus === "number" || newStatus.TAG !== /* AuthError */1) {
      return newStatus;
    } else {
      return ;
    }
  }
  if (typeof newStatus === "number") {
    return newStatus;
  }
  if (newStatus.TAG !== /* LoggedIn */0) {
    return newStatus;
  }
  var newUser = newStatus._0;
  if (oldStatus._0.token === newUser.token) {
    return ;
  } else {
    return {
            TAG: /* LoggedIn */0,
            _0: newUser
          };
  }
}

function getUserExn(authStatus) {
  if (typeof authStatus === "number" || authStatus.TAG !== /* LoggedIn */0) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expect to get LoggedIn(user)");
  } else {
    return authStatus._0;
  }
}

function addEventListener(prim0, prim1, prim2) {
  prim0.addEventListener(prim1, prim2);
  
}

function removeEventListener(prim0, prim1, prim2) {
  prim0.removeEventListener(prim1, prim2);
  
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.storeItemInBrowserStorage = storeItemInBrowserStorage;
exports.storeTokenInBrowserStorage = storeTokenInBrowserStorage;
exports.storeUserIdInBrowserStorage = storeUserIdInBrowserStorage;
exports.storeUserEmailInBrowserStorage = storeUserEmailInBrowserStorage;
exports.storeUserRoleInBrowserStorage = storeUserRoleInBrowserStorage;
exports.storeUserBuildInBrowserStorage = storeUserBuildInBrowserStorage;
exports.storeUserUserFlagsInBrowserStorage = storeUserUserFlagsInBrowserStorage;
exports.storeUserFinishedOnboardingInBrowserStorage = storeUserFinishedOnboardingInBrowserStorage;
exports.clearStoredTokenFromBrowserStorage = clearStoredTokenFromBrowserStorage;
exports.clearAllStoredUserInfoFromBrowserStorage = clearAllStoredUserInfoFromBrowserStorage;
exports.getTokenFromBrowserStorage = getTokenFromBrowserStorage;
exports.getFromBrowserStorage = getFromBrowserStorage;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.calcAuthStatusUpdate = calcAuthStatusUpdate;
exports.getUserExn = getUserExn;
/* User-SmartcutsMacros Not a pure module */
